// extracted by mini-css-extract-plugin
export var carrierTab = "_5p-0";
export var carrierTabActive = "_5p-1 _5p-0";
export var carrierTabInactive = "_5p-2 _5p-0";
export var carrierTabLabel = "_5p-3";
export var carrierTabLabelActive = "_5p-4 _5p-3";
export var carrierTabLabelInactive = "_5p-5 _5p-3";
export var carrierTabPercentage = "_5p-6";
export var carrierTabPercentageActive = "_5p-7 _5p-6";
export var carrierTabPercentageInactive = "_5p-8 _5p-6";
export var carrierTabWinnable = "_5p-9";
export var carrierTabWinnableActive = "_5p-a _5p-9";
export var carrierTabWinnableInactive = "_5p-b _5p-9";
export var comparisonContainer = "_5p-d";
export var missingRateButton = "_5p-n";
export var missingRateButtonActive = "_5p-o _5p-n";
export var missingRateButtonInactive = "_5p-p _5p-n";
export var missingRateButtonLabel = "_5p-q";
export var missingRateButtonLabelActive = "_5p-r _5p-q";
export var missingRateButtonLabelInactive = "_5p-s _5p-q";
export var sidebar = "_5p-c";
export var strategyButton = "_5p-e";
export var strategyButtonActive = "_5p-f _5p-e";
export var strategyButtonDescription = "_5p-k";
export var strategyButtonDescriptionActive = "_5p-l _5p-k";
export var strategyButtonDescriptionInactive = "_5p-m _5p-k";
export var strategyButtonInactive = "_5p-g _5p-e";
export var strategyButtonLabel = "_5p-h";
export var strategyButtonLabelActive = "_5p-i _5p-h";
export var strategyButtonLabelInactive = "_5p-j _5p-h";
export var unitToggleButton = "_5p-t";
export var unitToggleButtonActive = "_5p-u _5p-t";
export var unitToggleButtonInactive = "_5p-v _5p-t";
export var unitToggleButtonLabel = "_5p-w";
export var unitToggleButtonLabelActive = "_5p-x _5p-w";
export var unitToggleButtonLabelInactive = "_5p-y _5p-w";